import { faqContactForm, i18n } from "commonAssets/js/constants";
import { createElement } from "./createElement.js";
import { toggleContactForm } from "./toggleContactForm.js";
import { displayFaqAnswer } from "./displayFaqAnswer.js";

export function filterFaq(Elem) {
    const secondContactDropDownElem = document.getElementById("contactTopic");
    if (secondContactDropDownElem) {
        secondContactDropDownElem.parentElement.remove();
    }
    const faqAnswerElem = document.getElementById("faqAnswer");
    if (faqAnswerElem) {
        faqAnswerElem.remove();
    }

    const faqConfirmElem = document.getElementById("faqConfirm");
    if (faqConfirmElem) {
        faqConfirmElem.remove();
    }

    if (Elem.value === "") {
        toggleContactForm();
        return;
    }
    const secondLevelOptions = faqContactForm.faq[Elem.value];
    const secondLevelOptionsKeys = Object.keys(secondLevelOptions);
    const secondContactDropDown = createElement(
        "div",
        { class: "form-group" },
        [
            createElement(
                "label",
                { for: "contactTopic" },
                [],
                i18n.getTranslation("topic")
            ),
            createElement(
                "select",
                { class: "form-select", id: "contactTopic", required: true },
                [
                    createElement(
                        "option",
                        { value: "" },
                        [],
                        i18n.getTranslation("contact_us_select_a_reason")
                    ),
                    ...secondLevelOptionsKeys.map((category) =>
                        createElement(
                            "option",
                            { value: category },
                            [],
                            category
                        )
                    ),
                    createElement(
                        "option",
                        { value: "" },
                        [],
                        i18n.getTranslation("contact_us_select_other")
                    ),
                ],
                ``,
                {
                    change: (event) => {
                        displayFaqAnswer(
                            document.getElementById("contactCategory").value,
                            event.target
                        );
                    },
                }
            ),
        ]
    );
    Elem.parentElement.parentElement.appendChild(secondContactDropDown);
}
